import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import WindmillBlades from "../../assets/windmill_blades.png";
import "./Windmills.scss";

function Windmills() {
  const [width, setWidth] = useState(window.innerWidth);

  const updateWindowDimensions = () => {
    setWidth(window.innerWidth)
  }

  useEffect(() => {
    window.addEventListener('resize', updateWindowDimensions);
    return () => {
      window.removeEventListener('resize', updateWindowDimensions)
    }
  }, [])

  const percentageReturner = () => {
    if (1024 < width && width <= 1100) {
      return 81
    } else if (1100 < width && width <= 1200) {
      return 80.5;
    } else if (1200 < width && width <= 1300) {
      return 80;
    } else if (1300 < width && width <= 1450) {
      return 79.5;
    } else if (1450 < width && width <= 1550) {
      return 79;
    } else if (1550 < width && width <= 2000) {
      return 78.5;
    } else if (2000 < width && width <= 2250) {
      return 78.0;
    } else if (2250 < width) {
      return 77.5;
    }
    return 79.5;
  }

  return (
    <div className="windmills">
      <div className="windmill-left-wrapper">
        <motion.img
          style={{ left: `calc(${width / 2 + 10}px - ${percentageReturner()}%)` }}
          className="windmill-left"
          animate={{
            rotate: 360,
          }}
          src={WindmillBlades}
          alt="windmill-blades"
          transition={{
            loop: Infinity,
            ease: "linear",
            duration: 20,
          }}
        ></motion.img>
      </div>
      <div className="windmill-right-wrapper">
        <motion.img
          style={{ right: `calc(${width / 2 + 10}px - ${percentageReturner()}%)` }}
          className="windmill-right"
          animate={{
            rotate: 360,
          }}
          src={WindmillBlades}
          alt="windmill-blades"
          transition={{
            loop: Infinity,
            ease: "linear",
            duration: 20,
          }}
        ></motion.img>
      </div>
    </div>
  );
}

export default Windmills;
